import axios from "axios";

const url = "/distributor/admin/api/v1/programs";

export function getEditProgramProductDropdown(id){
  return new Promise((resolve, reject) => {
    axios.get(`${url}/${id}/get-product-dropdown`)
      .then(response => {
        return resolve(response.data)
      })
      .catch(error => {
        return reject(error.response.data)
      })
  })
}